export default async function () {
  await import('@spectrum-web-components/bundle/elements.js');
}
